import * as React from "react";
const SvgCropLandscape = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 13, rx: 1.5, stroke: "currentColor" }));
export default SvgCropLandscape;
